import messages from './messages.json';

// Language changes use ordinary links so data and forms are initialised consistently.
export const LANGUAGE = process.env.REACT_APP_SITE_LANGUAGE || (typeof window !== 'undefined' ? window.location.pathname.match(/^\/(de|fr)(?:\/|$)/)?.[1] : null) || 'it';
export const LANGUAGES = ['it', 'de', 'fr'];
export const languageTag = LANGUAGE + '-CH';
export const languageBase = LANGUAGE === 'it' ? '' : '/' + LANGUAGE;
export function translate(text, values = {}) {
  const key = text.replace(/\s+/g, ' ').trim();
  const value = messages[key]?.[LANGUAGE];
  const translated = LANGUAGE === 'it' || !value ? text : (text.match(/^\s*/)[0] + value + text.match(/\s*$/)[0]);
  return translated.replace(/\{(\d+)\}/g, (match, key) => values[key] ?? match);
}
export function languagePath(path, language = LANGUAGE) {
  const clean = path.replace(/^\/(de|fr)(?=\/|$)/, '') || '/';
  return (language === 'it' ? '' : '/' + language) + (clean.startsWith('/') ? clean : '/' + clean);
}
export function localHref(href) {
  if (typeof href !== 'string' || !/^\/(?:$|[?#]|prodotti(?:\/|$)|catalogo(?:\/|$)|servizi(?:\/|$)|proposte(?:\/|$))/.test(href)) return href;
  return languagePath(href);
}
